import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import Button from "components/basic/button";
import Modal from "components/basic/modal";
import TextArea from "components/basic/textArea";
import Typography from "components/basic/typography";

interface ReasonDialogProps {
  title: string;
  body: string;
  confirmLabel: string;
  loading: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

/** Asks for the reason a vendor is emailed with an admin's decision. */
const ReasonDialog: React.FC<ReasonDialogProps> = ({
  title,
  body,
  confirmLabel,
  loading,
  onConfirm,
  onClose,
}) => {
  const theme = useTheme();
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string>();

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError("Please give a reason");
      return;
    }
    onConfirm(reason.trim());
  };

  return (
    <Modal onClose={onClose}>
      <Box sx={{ width: { xs: "min(320px, 100vw - 64px)", sm: 440 } }}>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", marginBottom: 12 }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          style={{ color: theme.palette.text.secondary, marginBottom: 12 }}
        >
          {body}
        </Typography>
        <TextArea
          minRows={4}
          maxRows={8}
          placeHolder="Reason"
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
            setError(undefined);
          }}
          error={error}
        />
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button variant="text" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="error" onClick={handleConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ReasonDialog;
